import { Tooltip, TooltipProps } from '@material-ui/core';

export const CustomTooltip = ({ className, arrow = false, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow={arrow} classes={{ popper: className }} />
);
